module.exports = __webpack_public_path__ + "media/images/logo-sfa-9a390c67a0462d3e7e703b85bf148db9.png";